import React, { useState } from 'react';
import transformArrayToObject from '~/utils/transformArrayToObject';

const PendingFilesProv = React.createContext({
  data: {
    data: [],
    page: 0,
    totalCount: 0,
  },
  records: {},
  setData: () => null,
  modifyData: () => null,
  deleteRecord: () => null,
});

export function PendingFilesProvider({ children }) {
  const [records, setRecords] = useState({});
  const [data, setData] = useState({
    data: [],
    page: 0,
    totalCount: 0,
  });

  function addRecords(newData) {
    setData({ ...data, ...newData });

    const newRecords = transformArrayToObject(newData.data);
    setRecords({ ...records, ...newRecords });

    return newData;
  }

  return (
    <PendingFilesProv.Provider value={{ data, addRecords, records }}>
      {children}
    </PendingFilesProv.Provider>
  );
}

export default PendingFilesProv;
